/* eslint-disable */
import React from "react"
import { numberFormatter } from "../../../../utils/numbers.utils"
import { getMonthShortNameByNumber } from "../../../../utils/date.utils"
import { clsx } from "../../../../utils/strings.utils"
import Tooltip from "../../../../components/atoms/Tooltip.atom"
import { getAnniversaryInfoFromRange } from "../../../../utils/vacation.utils"
import { DateTime } from "luxon"

const ColumnContent = (rangeToConsider, monthToHighlight, anniversaryDate) => {
  const anniversaryDateTime = DateTime.fromISO(anniversaryDate)
  const day = anniversaryDateTime.day
  const monthName = anniversaryDateTime.monthLong

  return [
    ...rangeToConsider.map(({ month, year }, index) => {
      const { isAnniversary, anniversaryNumber } = getAnniversaryInfoFromRange(
        index,
        rangeToConsider,
        anniversaryDate
      )

      const toolTipContent = `${day} de ${monthName} ${year} inicio de año ${anniversaryNumber}`
      const penultimateOrLastMonth =
        index === rangeToConsider.length - 2 ||
        index === rangeToConsider.length - 1

      return {
        key: index,
        field: `monthsData`,
        header: () => {
          const className = `header-${month}-${year}`
          return (
            <>
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className={className} style={{ margin: 0 }}>
                  {getMonthShortNameByNumber(month).toUpperCase()}
                </p>
                {isAnniversary && (
                  <>
                    <div
                      className="anniversary-marker-container"
                      id={`anniversary-marker-container-${year}`}
                    >
                      <span className="anniversary-marker">
                        {penultimateOrLastMonth ?
                          anniversaryNumber
                        : "Inicio año " + anniversaryNumber}
                      </span>
                    </div>

                    <Tooltip
                      target={`#anniversary-marker-container-${year}`}
                      position="top"
                    >
                      {toolTipContent}
                    </Tooltip>
                  </>
                )}
              </div>
              <Tooltip target={`.${className} `} position="top">
                {year}
              </Tooltip>
            </>
          )
        },
        body: (rowData) => {
          return (
            <span
              className={clsx(
                "flex align-items-center gap-1 justify-content-center text-center",
                rowData.monthsData[index].daysCounter < 0 && "negative-days"
              )}
              style={{
                maxWidth: "41px",
                minWidth: "41px",
              }}
            >
              {numberFormatter(rowData.monthsData[index].daysCounter)}
            </span>
          )
        },
        className: clsx(
          "bucket-days-info-table__row-month",
          "flex justify-content-center",
          index === monthToHighlight &&
            "bucket-days-info-table__highlighted-month",
          index < monthToHighlight &&
            "bucket-days-info-table__months-past-anniversary"
        ),
        headerClassName: clsx(
          "bucket-days-info-table__row-month--header",
          "flex justify-content-center",
          index === monthToHighlight &&
            "bucket-days-info-table__highlighted-month--header",
          index < monthToHighlight &&
            "bucket-days-info-table__months-past-anniversary--header"
        ),
      }
    }),
  ]
}

export default ColumnContent
